import { render, staticRenderFns } from "./AboutMemberCard.vue?vue&type=template&id=31e822c3&scoped=true&"
import script from "./AboutMemberCard.vue?vue&type=script&lang=js&"
export * from "./AboutMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./AboutMemberCard.vue?vue&type=style&index=0&id=31e822c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e822c3",
  null
  
)

export default component.exports